import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import PowerPackage from './power-package';
import StandardPackages from './standard-packages';

class Component extends BaseComponent {
    constructor() {
        super();
        this.state = { isHeaderOpen: false };
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState.isHeaderOpen != this.state.isHeaderOpen) {
            return true;
        }

        if (nextProps.kc_sale != this.props.kc_sale) {
            return true;
        }

        if (nextProps.logged_in != this.props.logged_in) {
            return true;
        }

        if (nextProps.voucher_upc != this.props.voucher_upc) {
            return true;
        }

        if (nextProps.sale_message != this.props.sale_message) {
            return true;
        }

        if (nextProps.submitting != this.props.submitting) {
            return true;
        }

        return false;
    }

    render() {
        return (
            <karmacoin-store>
                <form>
                    {this.renderDiscountMessage()}
                    <h1>Karma Coins<sup>®</sup> Store</h1>
                    <p>
                        Buy in bulk and get your favorite Tarot readings, Astrology reports, Numerology reports, and I
                        Ching readings for up to 50% off! <a onClick={this.toggleAside}>Learn More</a>
                    </p>
                    {this.renderAside()}
                    <div className='icon-mobile-discount-fifty-percent is-visible-mobile' />
                    <h6 className='package-header'>CHOOSE OUR <span>50% OFF</span> POWER PACKAGE:</h6>
                    <PowerPackage />
                    <h6 className='package-header'>OR CHOOSE A <span>STANDARD PACKAGE</span>:</h6>
                    <StandardPackages />
                    {this.renderSubmit()}
                </form>
            </karmacoin-store>
        );
    }

    renderDiscountMessage = () => {
        if (this.props.logged_in && this.props.sale_message) {
            return (<p className='sale-msg'>{this.props.sale_message}</p>);
        }

        return null;
    }

    renderAside = () => {
        if (this.state.isHeaderOpen) {
            return (
                <aside>
                    <a className='learn-more-close-button' onClick={this.toggleAside}>x</a>
                    <h3>What Are Karma Coins?</h3>
                    <p>
                        Karma Coins<sup>®</sup> (KCs for short) are digital credits used to purchase Tarot.com
                        products. What is the benefit of using KCs instead of cash? You receive a discount on
                        everything you purchase!
                    </p>
                    <h3>Why Should I Use Karma Coins?</h3>
                    <p>
                        <ul>
                            <li>Big Savings: Receive up to 50% OFF all your purchases when you buy in bulk</li>
                            <li>
                                One-Click: Skip the tedious credit card form and get right to your personalized
                                insight!
                            </li>
                            <li>
                                Easy Tracking: Your KC balance is displayed at the top of each Tarot.com page for your
                                convenience
                            </li>
                        </ul>
                    </p>
                </aside>
            );
        }

        return null;
    }

    toggleAside = () => {
        this.trackEvent('Click-Learn-More');
        this.setState({isHeaderOpen: !this.state.isHeaderOpen});
    }

    renderSubmit = () => {
        return (
            <button onClick={this.trackClick} className='button-warning'>
                {this.props.submitting ? 'submitting…' : 'purchase coins'}
            </button>
        );
    }

    trackEvent = (action) => {
        let label = 'logged-out';

        if (this.props.logged_in) {
            label = this.props.voucher_upc == 'first-time-kc-package-offer'
                ? '1st-kc-package'
                : '2nd-or-more-kc-package';
        }

        this.props.trackEvent([ 'kc-store', action, label ]);
    }

    trackClick = (e) => {
        e.preventDefault();

        if (!this.props.submitting) {
            this.trackEvent('Click-Purchase-Button');
            this.props.purchase();
        }

        return false;
    }
}

const mapStateToProps = (state) => ({
    kc_sale: state['karmacoin-store'] && state['karmacoin-store'].kc_sale,
    logged_in: state.user && state.user.logged_in,
    voucher_upc: state['karmacoin-store'].packages && state['karmacoin-store'].packages.standard[0].voucher_upc,
    sale_message: state['karmacoin-store'].packages && state['karmacoin-store'].packages.standard[0].message,
    submitting: state.product.submitting,
});

const mapDispatchToProps = (dispatch) => ({
    purchase: () => dispatch({ type: 'karmacoin-store:purchase' }),
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
